import { FC, RefObject, useCallback, useEffect, useRef, useState } from "react";
import { ChatInputProps } from "./types";
import { useThemeStore } from "../../../../stores";

const MAX_ROWS = 4;

const ChatInput: FC<ChatInputProps> = ({
  value,
  setValue,
  isSidePanel,
  className = "",
  props,
  style = {},
}) => {
  const theme = useThemeStore((s) => s.theme);
  const ref: RefObject<HTMLTextAreaElement> = useRef<HTMLTextAreaElement>(null);

  const handler = useCallback(
    (e: MouseEvent): void => {
      if ((e.target as Element).tagName.toLowerCase() !== "textarea") {
        ref.current?.blur();
      }
    },
    [ref]
  );

  useEffect(() => {
    window.addEventListener("click", handler);
    return (): void => {
      window.removeEventListener("click", handler);
    };
  }, [handler]);

  const [rows, setRows] = useState<number>(1);

  const onScroll = (e: React.UIEvent<HTMLTextAreaElement, UIEvent>): void => {
    if (!ref.current || !value) return;

    const scrollHeight = e.currentTarget.scrollHeight;
    const lineHeight = window.getComputedStyle(ref.current).lineHeight;
    const lineHeightNumber = Number(
      lineHeight.substring(0, lineHeight.length - 2)
    );

    setRows(
      scrollHeight / lineHeightNumber > MAX_ROWS
        ? MAX_ROWS
        : scrollHeight / lineHeightNumber
    );
  };

  useEffect(() => {
    if (!value) setRows(1);
  }, [value]);

  return (
    <textarea
      ref={ref}
      style={{
        resize: "none",
        color: isSidePanel ? theme.textOnBg : theme.textOnOverlay,
        background: "transparent",
        width: "100%",
        ...style,
      }}
      {...props}
      className={className}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      rows={rows}
      onScroll={onScroll}
    ></textarea>
  );
};

export default ChatInput;
